import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';
import { getPerformance } from 'firebase/performance';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyDU18VmV-DtT71eUku1tDFxP8wRf733908',
  authDomain: 'trade-tradyfi.firebaseapp.com',
  projectId: 'trade-tradyfi',
  storageBucket: 'trade-tradyfi.firebasestorage.app',
  messagingSenderId: '633127353123',
  appId: '1:633127353123:web:33065fad43acc77a3aea96',
  measurementId: 'G-L23V39ZTKC',
  databaseURL:
    'https://trade-tradyfi-default-rtdb.asia-southeast1.firebasedatabase.app',
};

const app = initializeApp(firebaseConfig);

const firebaseAnalytics = getAnalytics(app);
const firebaseStorage = getStorage(app);
const firebaseFirestore = getFirestore(app);
const firebaseDatabase = getDatabase(app);
const firebaseAuth = getAuth(app);
const firebasePerformance = getPerformance(app);

export {
  firebaseAnalytics,
  firebaseAuth,
  firebaseDatabase,
  firebaseFirestore,
  firebasePerformance,
  firebaseStorage,
};
